export const AUTH_FAILED_REQUEST = 'AUTH_FAILED_REQUEST';
export const AUTH_LOADING_REQUEST = 'AUTH_LOADING_REQUEST';

export const AUTH_LOGIN_SUCCESS = 'AUTH_LOGIN_SUCCESS';

export const AUTH_LOGOUT_SUCCESS = 'AUTH_LOGOUT_SUCCESS';
